import type { ReactNode } from 'react';
import type { PageExperience } from '@/features/experiences/types';
import { getStyleById } from '../../../theme';

type Props = {
  experience: PageExperience;
  pageIndex: number;
  children: ReactNode;
};

export const GridContainer = ({ children, experience, pageIndex }: Props) => {
  const theme = getStyleById(experience.styleId ?? undefined);

  return (
    <div
      data-measure={`grid-${pageIndex}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflow: 'hidden',
        border: `2px solid ${theme.accentColor || '#000000'}`,
        borderRadius: '0.5em',
        position: 'absolute',
        height: '100%',
        width: '100%',
        inset: 0,
      }}
    >
      {children}
    </div>
  );
};
